@if(modal()){
<h2 mat-dialog-title>{{ dataModule.name }}</h2>
<mat-dialog-content class="mat-typography">
  <ng-container *ngTemplateOutlet="editor"></ng-container>
</mat-dialog-content>
@if(showClose()){
  <mat-dialog-actions align="end">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </mat-dialog-actions>
}
}@else{
  
  <div class="p-16 d-flex align-items-center justify-content-between"
  cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  ngxResizable
  [ngxResizableDisabled]="!resizable()"
  [cdkDragDisabled]="!draggable()"
  [ngxResizableTargetElement]="'.mat-mdc-dialog-surface'"
  [ngxResizableEventClass]="'modal-file-resizing'"
  >
    <h3>{{ dataModule.name }}
      @if(dataModule.page){
        - {{ 'filemanager.file.page' | translate }}:{{dataModule.page}}
      }
    </h3>
    @if(showClose()){
      <div class="close-button close">
        <button mat-icon-button (click)="closeDirect()">
          <i-tabler name="xbox-x"></i-tabler>
        </button>
      </div>
    }
  </div>
  <ng-container *ngTemplateOutlet="editor"></ng-container>
  <div class="actions border-top-solid">
   <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>  
}


<ng-template #editor>
  <div class="d-flex align-items-center gap-16 p-16">
    <mat-label class="d-block flex-shrink-0">{{ 'filemanager.pdf.extract_page_label' | translate }}</mat-label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <input matInput type="number" [formControl]="numberPage" [min]="1" [step]="1" [placeholder]="'filemanager.pdf.page_number_placeholder' | translate"/>
      <!-- <mat-icon matPrefix class="op-5">
        <i-tabler name="page-break" class="icon-20 d-flex"></i-tabler>
      </mat-icon> -->
      <button mat-button matSuffix (click)="cutPage()" [class.bg-primary]="numberPage.valid" [class.text-white]="numberPage.valid" [disabled]="!numberPage.valid">
        <i-tabler name="scissors"></i-tabler>
      </button>
      <mat-error *ngIf="numberPage.invalid && numberPage.touched">
        @if (numberPage.errors?.['required']) {
          <span>{{ 'filemanager.pdf.error_required' | translate }}</span>
        }
        @if (numberPage.errors?.['min']) {
          <span>{{ 'filemanager.pdf.error_min' | translate }}</span>
        }
        @if (numberPage.errors?.['pattern']) {
          <span>{{ 'filemanager.pdf.error_pattern' | translate }}</span>
        }
      </mat-error>
    </mat-form-field>
      
  </div>
  <div class="frame-container">
    <iframe [src]="fileData" style="width: 100%;height: calc(60vh - 40px)"></iframe>
  </div>
</ng-template>

<ng-template #actions>
  <div class="p-16 d-flex align-items-center justify-content-end gap-16">
  <button mat-flat-button class="bg-error text-white" (click)="closeDirect()">{{ 'filemanager.viewer.close' | translate }}</button>
  </div>
</ng-template>